import { withCommonPreloads } from './commons/commonPreloads';
import { getFares } from '../../../_integrations/everymundo/carPackage';
import commonPlainFaresPreload from './commons/commonPlainFaresPreload';

const preloadCustomProps = (cmpConfig) => {
  // HOC For all Common Preload Logic
  return withCommonPreloads(
    commonPlainFaresPreload,
    cmpConfig,
    'initialDestinationCards',
    getFares
  );
};

export default preloadCustomProps;
